import { Component } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import 'rxjs/add/operator/finally';
import { FormErrorInterface } from '../../../support/form-errors/form-error.interface';
import { LoaderService } from '../../../support/loading/loader.service';
import { RouteService } from '../../../routing/services/route.service';
import { SessionService } from '../../../support/sessions/session.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'chassis-auth-forgot-password-component',
    templateUrl: 'forgot-password.component.html',
    styleUrls: ['forgot-password.component.scss'],
})
export class ForgotPasswordComponent {

    public form: {
        email?: string,
    } = {};

    public messages: { [key: string]: Array<FormErrorInterface> } | Array<FormErrorInterface> | FormErrorInterface;

    constructor(private auth: AuthenticationService, public loader: LoaderService, private routes: RouteService, private session: SessionService) {
    }

    public sendPasswordResetCode() {
        const loader = this.loader.create('send-password-reset-email').start();

        this.auth.sendPasswordResetCode(this.form).pipe(finalize(() => {
            loader.stop();
        })).subscribe(() => {
            this.routes.navigate('password-reset').then(() => {
                this.session.flash('password-reset', {
                    type: 'info',
                    message: 'Password reset email has been sent.',
                });

                console.log(this.session);
            });
        }, (response) => {
            this.setErrorAlerts(response.error);
        });
    }

    private setErrorAlerts(error) {
        if (error instanceof Object) {
            const messages = {};

            Object.keys(error).forEach((key) => {
                if (!messages[key]) {
                    messages[key] = [];
                }

                error[key].forEach((message) => {
                    messages[key].push({
                        type: 'danger',
                        message: message,
                    });
                });
            });

            this.messages = messages;
        } else {
            this.messages = {
                type: 'danger',
                message: error,
            };
        }
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/components/forgot-password/forgot-password.component.ts